import * as React from 'react'
import * as Context from '../contexts/root'
import Form from './Form'
import Preview from './Preview'
import Submit from './Submit'
import Success from './Success'
import * as FormContext from '../contexts/form'
import ClientOnly from 'components/ClientOnly'

export default function Screens() {
    const [state] = Context.useService()
    const { submissionID, ownsObservations, values } = state.context

    switch (true) {
        case state.matches('form'):
            return (
                <FormContext.Provider>
                    {/* Add <ClientOnly> to build in SLS, seems to be an internal issue within `react-hook-form`. */}
                    <ClientOnly>
                        <Form />
                    </ClientOnly>
                </FormContext.Provider>
            )
        case state.matches('preview'):
            return <Preview />
        case state.matches('submit'):
            return <Submit />
        case state.matches('success'):
            return (
                <Success
                    submissionID={submissionID}
                    ownsObservations={ownsObservations}
                    username={values.initial?.username}
                />
            )
        default:
            return null
    }
}
